import { TravellersRequiredInformationContent } from "../types/travellers-required-information.type";

export interface MagnoliaRequiredInformationResponse {
  pageTitle?: string;
  identificationTypePlaceholder?: string;
  identificationNumberPlaceholder?: string;
  dniLabel?: string;
  nieLabel?: string;
  passportLabel?: string;
  identificationTypeRequiredForNumberError?: string;
  identificationNumberInvalidFormatError?: string;
  identificationNumberWarning?: string;
  addressLine1Placeholder?: string;
  addressLine2Placeholder?: string;
  cityPlaceholder?: string;
  postalCodePlaceholder?: string;
  addressLine1Warning?: string;
  cityWarning?: string;
  postalCodeWarning?: string;
  addressLine1InvalidCharsError?: string;
  addressLine2InvalidCharsError?: string;
  cityInvalidFormatError?: string;
  postalCodeInvalidFormatError?: string;
  continueButtonText?: string;
  optionalText?: string;
  emptyStateHeading?: string;
  emptyStateDescription?: string;
  emptyStateIconUrl?: string;
  filledStateHeading?: string;
  filledStateDescription?: string;
  filledStateIconUrl?: string;
  identificationTypeRequiredError?: string;
  identificationNumberRequiredError?: string;
  alertMessageIncompleteSectionSingle?: string;
  alertMessageIncompleteSection?: string;
  alertMessageLinkSectionSingle?: string;
  alertMessageLinkSection?: string;
  requiredInformationArea?: {
    "0"?: MagnoliaRequiredInformationResponse;
  };
}

export function mapMagnoliaToRequiredInformationContent(
  magnoliaData?: MagnoliaRequiredInformationResponse
): TravellersRequiredInformationContent {
  const content = magnoliaData?.requiredInformationArea?.["0"] || magnoliaData;

  if (!content) {
    return {};
  }

  return {
    pageTitle: content.pageTitle ?? "",

    organiserSection: {
      addressSection: {
        line1Placeholder: content.addressLine1Placeholder ?? "",
        line2Placeholder: content.addressLine2Placeholder ?? "",
        cityPlaceholder: content.cityPlaceholder ?? "",
        postalCodePlaceholder: content.postalCodePlaceholder ?? "",
        errors: {
          line1InvalidChars: content.addressLine1InvalidCharsError ?? "",
          line2InvalidChars: content.addressLine2InvalidCharsError ?? "",
          cityInvalidFormat: content.cityInvalidFormatError ?? "",
          postalCodeInvalidFormat: content.postalCodeInvalidFormatError ?? "",
        },
        warnings: {
          line1Warning: content.addressLine1Warning ?? "",
          cityWarning: content.cityWarning ?? "",
          postalCodeWarning: content.postalCodeWarning ?? "",
        },
      },
      identificationSection: {
        typePlaceholder: content.identificationTypePlaceholder ?? "",
        numberPlaceholder: content.identificationNumberPlaceholder ?? "",
        typeOptions: {
          dniLabel: content.dniLabel ?? "",
          nieLabel: content.nieLabel ?? "",
          passportLabel: content.passportLabel ?? "",
        },
        errors: {
          identificationNumberInvalidFormat:
            content.identificationNumberInvalidFormatError ?? "",
          typeRequiredForNumber:
            content.identificationTypeRequiredForNumberError ?? "",
        },
        warnings: {
          numberWarning: content.identificationNumberWarning ?? "",
        },
      },
    },

    descriptionSection: {
      emptyState: {
        heading: content.emptyStateHeading ?? "",
        description: content.emptyStateDescription ?? "",
        iconUrl: content.emptyStateIconUrl ?? "",
      },
      filledState: {
        heading: content.filledStateHeading ?? "",
        description: content.filledStateDescription ?? "",
        iconUrl: content.filledStateIconUrl ?? "",
      },
    },

    footer: {
      continueButtonText: content.continueButtonText ?? "",
    },

    translations: {
      optional: content.optionalText ?? "",
    },

    errorMessages: {
      alertMessageIncompleteSectionSingle:
        content.alertMessageIncompleteSectionSingle ?? "",
      alertMessageIncompleteSection:
        content.alertMessageIncompleteSection ?? "",
      alertMessageLinkSectionSingle:
        content.alertMessageLinkSectionSingle ?? "",
      alertMessageLinkSection: content.alertMessageLinkSection ?? "",
    },
  };
}
